import { render, staticRenderFns } from "./digital_notice.vue?vue&type=template&id=b6d0e956&scoped=true"
import script from "./digital_notice.vue?vue&type=script&lang=js"
export * from "./digital_notice.vue?vue&type=script&lang=js"
import style0 from "./digital_notice.vue?vue&type=style&index=0&id=b6d0e956&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d0e956",
  null
  
)

export default component.exports